import React from 'react';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { TOOLTIP_DURATION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from 'src/view/components/Text/Text';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';

interface IProps {
  title: string;
  className?: string;
}

const MenuManagTabItemPriceHeader: React.FC<IProps> = (props: IProps): JSX.Element => {
  const vatIconTitle: string = localeStore.t(appStore.settings?.vat_included ? 'vat_incl' : 'vat_excl');
  const vatTooltipMessage: string = appStore.settings?.vat_included ? 'vat_included_in_price' : 'vat_excluded_from_price';

  return (
    <div className={`d-flex flex-row align-items-center justify-content-between ${props.className || ''}`}>
      <Text type={TEXT.BLOCK_HEADER} text={props.title} required />
      <div className="d-flex flex-row align-items-center">
        <p className="family-medium text-size-12 color-dark mr-2">{vatIconTitle}</p>
        <TooltipIcon message={vatTooltipMessage} duration={TOOLTIP_DURATION.EXTRA_LARGE} />
      </div>
    </div>
  );
};

export default MenuManagTabItemPriceHeader;
